import { createSlice } from '@reduxjs/toolkit'

// reducer
import { commentReducers } from '@/stores/slices/Labeling/reducers/comment'
import { socketReducers } from '@/stores/slices/Labeling/reducers/socket'
import { toolReducers } from '@/stores/slices/Labeling/reducers/tool'
import { miscReducers } from '@/stores/slices/Labeling/reducers/misc'

// extraReducers
import { initializationExtraReducers } from '@/stores/slices/Labeling/extraReducers/initialization'
import { commentExtraReducers } from '@/stores/slices/Labeling/extraReducers/comment'
import { classExtraReducers } from '@/stores/slices/Labeling/extraReducers/class'
import { filesExtraReducers } from '@/stores/slices/Labeling/extraReducers/files'
import { objectsExtraReducers } from '@/stores/slices/Labeling/extraReducers/objects'
import { clsTagExtraReducers } from '@/stores/slices/Labeling/extraReducers/clsTag'
import { miscExtraReducers } from '@/stores/slices/Labeling/extraReducers/misc'

// const
import { initialState } from '@/stores/slices/Labeling/const'

export const labelingSlice = createSlice({
  name: 'labeling',
  initialState,
  reducers: {
    ...miscReducers, // 단축키, 클러스터링, cls필터, 초기화
    ...toolReducers, // 툴바 관련
    ...commentReducers, // 코멘트 관련
    ...socketReducers, // 소켓 관련 (object, comment)
  },
  extraReducers: (builder) => {
    initializationExtraReducers(builder)
    classExtraReducers(builder)
    clsTagExtraReducers(builder)
    miscExtraReducers(builder) // 단축키, updateRole
    filesExtraReducers(builder)
    commentExtraReducers(builder)
    objectsExtraReducers(builder)
  },
})

export const {
  // misc
  setClassTagFilter,
  resetClassTagFilter,
  setHasSelectedForClustering,
  updateUserShortcuts,
  setHotkeysEnabled,
  setShowFloatingZoomMenu,
  resetCurrentLabeling,

  // tool
  setClass,
  setTool,
  setBrush,
  setOpacity,
  setMagicWandThreshold,
  setAutoPixelType,
  toggleBrushAutoFill,
  toggleRgbChannel,
  toggleObjectVisibility,
  setTracking,
  updatePropmptImageIds,
  setIsRunningSemiAutoLabeling,

  // comment
  createTempComment,
  deleteTempComment,

  // socket - object
  socketAddObjects,
  socketDeleteObjects,
  socketDeleteAllObjects,
  socketUpdateObjects,
  socketStartLabelAssistant,
  socketFinishLabelAssistant,
  socketUndoRedo,

  // socket - labelingItem
  socketToggleItemStatus,

  // socket - comment
  socketCreateReviewObject,
  socketAppendComment,
  socketDeleteComment,
  socketToggleResolveComment,
  socketConfirmAllComments,

  // socket - classification tag
  socketAddTag,
  socketDeleteTag,

} = labelingSlice.actions

export default labelingSlice.reducer
